export const mobileMaxWidth = 863;
export const isMobile = window.innerWidth <= mobileMaxWidth;

// Sounds game
export const winGameSoundURL = "https://test.gobeb.co.il/sound/win.mp3";
export const loseGameSoundURL = "https://test.gobeb.co.il/sound/lose.mp3";
// export const cardPlaySoundURL = "https://privat-storage.s3.eu-west-3.amazonaws.com/cardplay.mp3";
export const wrongBidSoundURL = "https://test.gobeb.co.il/sound/fail.wav";
export const clickOneSoundURL = "https://test.gobeb.co.il/sound/click_one.mp3";
export const windowBalloonsSoundURL = "https://test.gobeb.co.il/sound/WindowsBalloon.wav";
export const magicChimeSoundURL = "https://test.gobeb.co.il/sound/magicchime01.mp3";
export const speechOffSoundURL = "https://test.gobeb.co.il/sound/SpeechOff.mp3";
export const cardPlaySoundURL = "https://test.gobeb.co.il/sound/cardplay.mp3";
export const chimesSoundURL = "https://test.gobeb.co.il/sound/chimes.wav";
